//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { roterPre } from '@/settings';
export default {
  name: 'Page404',
  data: function data() {
    return {
      roterPre: roterPre
    };
  },
  computed: {
    message: function message() {
      return '抱歉，您访问的页面出错了';
    }
  }
};